import { motion } from "framer-motion";
import { Home, ArrowUpRight, Check } from "lucide-react";
import { ROOMS, IMAGES, ROOMS_HIGHLIGHTS } from "@/data/content";

export const Rooms = () => {
  return (
    <section
      id="wnetrza"
      data-testid="rooms-section"
      className="bg-[#EAE4D9] py-20 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold uppercase tracking-[0.2em] text-[#4A7055]">
            {ROOMS.eyebrow}
          </span>
          <h2 className="mt-4 font-display text-3xl font-semibold leading-tight text-[#2D3728] text-balance md:text-4xl lg:text-5xl">
            {ROOMS.title}
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 items-start gap-6 lg:grid-cols-2">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="overflow-hidden rounded-3xl"
          >
            <img
              src={IMAGES.livingRoom}
              alt="Przestronny, jasny salon"
              className="h-[340px] w-full object-cover sm:h-[400px] lg:h-[460px]"
            />
          </motion.div>

          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
            {ROOMS.floors.map((floor, idx) => (
              <motion.div
                key={floor.name}
                data-testid={`floor-card-${idx}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: idx * 0.1 }}
                className="flex flex-col rounded-3xl border border-[#D8CFBC] bg-[#F9F7F3] p-6"
              >
                <div className="flex items-center gap-2 text-[#4A7055]">
                  {idx === 0 ? (
                    <Home className="h-5 w-5" />
                  ) : (
                    <ArrowUpRight className="h-5 w-5" />
                  )}
                  <h3 className="font-display text-xl font-semibold text-[#2D3728]">
                    {floor.name}
                  </h3>
                </div>
                <ul className="mt-4 space-y-2.5">
                  {floor.items.map((item) => (
                    <li
                      key={item}
                      className="flex items-start gap-2 text-sm leading-relaxed text-[#4A5D43]"
                    >
                      <Check className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#9C5E4B]" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>
        </div>

        <div className="mt-24 flex flex-col items-start gap-8 lg:mt-32 lg:flex-row lg:gap-10">
          {ROOMS_HIGHLIGHTS.map((r, i) => (
            <motion.div
              key={r.alt}
              data-testid={`room-highlight-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: i * 0.12 }}
              className={`group relative w-full overflow-hidden rounded-[2rem] lg:w-1/3 ${
                i === 1 ? "lg:mt-16" : ""
              }`}
            >
              <img
                src={r.src}
                alt={r.alt}
                className={`w-full object-cover transition-transform duration-700 group-hover:scale-105 ${
                  i === 1 ? "h-[280px]" : "h-[380px]"
                }`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent" />
              <span className="font-display absolute bottom-5 left-6 text-lg font-semibold text-white">
                {r.label}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
